(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-drone-seo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pm-drone-page]').forEach((page) => {
    const content = page.querySelector('[data-pm-content]');
    const toc = page.querySelector('[data-pm-toc]');
    const tocList = page.querySelector('[data-pm-toc-list]');
    const mobileToc = page.querySelector('[data-pm-toc-mobile]');
    const mobileTocList = page.querySelector('[data-pm-toc-mobile-list]');
    const shareButton = page.querySelector('[data-pm-share]');
    const progress = page.querySelector('[data-pm-reading-progress]');
    const hero = page.querySelector('[data-pm-hero]');
    const finalCta = page.querySelector('[data-pm-final-cta]');
    const mobileCta = page.querySelector('[data-pm-mobile-cta]');

    if (content && !content.dataset.pmEnhanced) {
      content.dataset.pmEnhanced = 'true';

      content.querySelectorAll('table').forEach((table) => {
        const headers = [...table.querySelectorAll('thead th')].map((header) => header.textContent.trim());
        const fallbackHeaders = headers.length ? headers : [...table.querySelectorAll('tr:first-child th')].map((header) => header.textContent.trim());

        table.querySelectorAll('tbody tr').forEach((row) => {
          [...row.querySelectorAll('td')].forEach((cell, index) => {
            cell.dataset.label = fallbackHeaders[index] || '';
          });
        });
      });
    }

    if (content && tocList) {
      const headings = [...content.querySelectorAll('h2')];
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        let id = heading.id || heading.textContent.trim().toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '') || `section-${index + 1}`;
        const baseId = id;
        let suffix = 2;

        while (usedIds.has(id) || document.querySelectorAll(`#${CSS.escape(id)}`).length > 0) {
          id = `${baseId}-${suffix}`;
          suffix += 1;
        }

        usedIds.add(id);
        heading.id = id;

        [tocList, mobileTocList].filter(Boolean).forEach((list) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${id}`;
          link.textContent = heading.textContent;
          item.appendChild(link);
          list.appendChild(item);
        });
      });

      if (headings.length >= 2) {
        if (toc) toc.hidden = false;
        if (mobileToc) mobileToc.hidden = false;

        const links = [...page.querySelectorAll('[data-pm-toc-list] a')];
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => {
              link.toggleAttribute('aria-current', link.hash === `#${entry.target.id}`);
            });
          });
        }, { rootMargin: '-20% 0px -70%' });

        headings.forEach((heading) => observer.observe(heading));
      }
    }

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        try {
          if (navigator.share) {
            await navigator.share({ title: document.title, url: window.location.href });
            return;
          }
          await navigator.clipboard.writeText(window.location.href);
          const label = shareButton.querySelector('span');
          if (!label) return;
          const original = label.textContent;
          label.textContent = shareButton.dataset.copiedLabel || original;
          window.setTimeout(() => { label.textContent = original; }, 1800);
        } catch (error) {
          if (error.name !== 'AbortError') throw error;
        }
      });
    }

    if (progress) {
      const updateProgress = () => {
        const start = page.offsetTop;
        const distance = page.offsetHeight - window.innerHeight;
        const value = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
        progress.style.width = `${value * 100}%`;
      };
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
    }

    if (mobileCta && hero && window.matchMedia('(max-width: 749px)').matches) {
      let heroVisible = true;
      const updateMobileCta = () => {
        const beforeFinalCta = !finalCta || finalCta.getBoundingClientRect().top > window.innerHeight * 0.85;
        mobileCta.classList.toggle('is-visible', !heroVisible && beforeFinalCta);
      };

      const heroObserver = new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
        updateMobileCta();
      }, { threshold: 0.05 });

      heroObserver.observe(hero);

      if (finalCta) {
        window.addEventListener('scroll', updateMobileCta, { passive: true });
        window.addEventListener('resize', updateMobileCta);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
